import React from 'react'
import useWpJson from '../../Hooks/useWpJson'
import GalleryFromPost from './GalleryFromPost'
import Loader from '../../Components/Loader'
export default function FeaturedGallery ({ gallery,...props }) {
  const ids = gallery?.map(({ ID }) => ID).join(',')
  const catId = useWpJson(`posts?include=${ids}&acf_format=standard`)
  return catId ? <GalleryFromPost jsonResponse={catId} {...props} /> : <Loader />
}
